var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 47.6802H6V50.001H50V47.6802Z",
    fill: "#ACB3BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6166 29.0215H7.83325V45.8239H14.6166V29.0215Z",
    fill: "#CDD6E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0503 20.9452H16.267V45.8238H23.0503V20.9452Z",
    fill: "#4CDBC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3913 24.7518H24.608V45.8238H31.3913V24.7518Z",
    fill: "#FFD15C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8253 32.6418H33.042V45.7307H39.8253V32.6418Z",
    fill: "#84DBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1664 17.9749H41.3831V45.7307H48.1664V17.9749Z",
    fill: "#FF7058"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7834 22.6164L21.8584 9.52749L10.5834 20.9455L9.30005 19.6459L21.8584 6.92831L34.7834 20.0172L45.4167 9.249L46.7 10.5486L34.7834 22.6164Z",
    fill: "#CDD6E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 22.9752C11.5307 22.9752 12.65 21.8559 12.65 20.4752C12.65 19.0945 11.5307 17.9752 10.15 17.9752C8.76931 17.9752 7.65002 19.0945 7.65002 20.4752C7.65002 21.8559 8.76931 22.9752 10.15 22.9752Z",
    fill: "#40596B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0664 11C23.4471 11 24.5664 9.88071 24.5664 8.5C24.5664 7.11929 23.4471 6 22.0664 6C20.6857 6 19.5664 7.11929 19.5664 8.5C19.5664 9.88071 20.6857 11 22.0664 11Z",
    fill: "#40596B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9003 24.0892C36.281 24.0892 37.4003 22.9699 37.4003 21.5892C37.4003 20.2085 36.281 19.0892 34.9003 19.0892C33.5196 19.0892 32.4003 20.2085 32.4003 21.5892C32.4003 22.9699 33.5196 24.0892 34.9003 24.0892Z",
    fill: "#40596B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2664 12.5781C47.6471 12.5781 48.7664 11.4588 48.7664 10.0781C48.7664 8.69735 47.6471 7.57806 46.2664 7.57806C44.8856 7.57806 43.7664 8.69735 43.7664 10.0781C43.7664 11.4588 44.8856 12.5781 46.2664 12.5781Z",
    fill: "#40596B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.bae86e4e42318d9b901f6d401d18089b.svg";
export { ForwardRef as ReactComponent };